import {useEffect} from 'react'
import {config} from '../../config'
import {setCookie} from '../../common/utils'

export function RedirectLogin() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const pammManagerId = params.get('pammManager')
    const pammOfferId = params.get('pammOffer')

    if (pammManagerId && pammOfferId) {
      setCookie(
        'pammOffer',
        encodeURIComponent(JSON.stringify({pammManagerId, pammOfferId})),
        1
      )
    }

    // Clean redirect — no need to keep the query string
    window.location.href = `${config.newFrontendUrl}/log-in`
  }, [])
  return null
}

export function RedirectSignUp() {
  useEffect(() => {
    const search = window.location.search
    window.location.href = `${config.newFrontendUrl}/sign-up${search}`
  }, [])
  return null
}

export function RedirectSignUpPartner() {
  useEffect(() => {
    const search = window.location.search
    window.location.href = `${config.newFrontendUrl}/sign-up/partner${search}`
  }, [])
  return null
}

export function RedirectForgotPassword() {
  useEffect(() => {
    window.location.href = `${config.newFrontendUrl}/password-recover`
  }, [])
  return null
}
